import { RANKS } from "../content/ranks";

/**
 * Index of the highest rank whose Phase 1 score threshold the score meets.
 * Ranks are now earned in trials; this is only used to migrate old saves.
 */
export function rankFor(score: number, ranks = RANKS): number {
  let i = 0;
  ranks.forEach((r, j) => {
    if (score >= r.score) i = j;
  });
  return i;
}
